<script setup>
import DashboardCanvas from '@/components/dashboard-overview/DashboardCanvas.vue'
import { nodeViewProps, NodeViewWrapper } from '@tiptap/vue-3'
import CustomNodeEditMenu from '@/components/wysiwyg-components/nodes/CustomNodeEditMenu.vue'

const props = defineProps(nodeViewProps)

let timestamp = null
if (props.node.attrs.timestamp !== null) {
  try {
    timestamp = parseInt(props.node.attrs.timestamp)
  } catch {}
}

const canvasId = props.node.attrs.canvasId || null
const imageSource = props.node.attrs.imageSource || 'stillFrame'
</script>

<template>
  <node-view-wrapper
    as="div"
    class="d-block"
  >
    <CustomNodeEditMenu
      :variant-parameters="{ timestamp, canvasId, imageSource }"
      current-variant="canvas"
      :variants="[
        { tag: 'inline-canvas', label: 'Inline', icon: 'mdi-text' },
        { tag: 'canvas', label: 'Canvas', icon: 'mdi-artboard' },
      ]"
      :node-props="props"
    >
      <template #element="nodeProps">
        <DashboardCanvas
          v-bind="nodeProps"
          :timestamp="timestamp"
          :canvas-id="canvasId"
          :preset-image-source="imageSource"
        />
      </template>
    </CustomNodeEditMenu>
  </node-view-wrapper>
</template>

<style scoped></style>
